<kendo-dialog *ngIf="dialogOpened" (close)="close();" [width]="450">
    <kendo-dialog-titlebar>
        <h3>{{ 'ACTIVE-ORGANIZATIONS' | translate}}</h3>
    </kendo-dialog-titlebar>
    <div class="mt-2">
        <label class="k-form-field w-100">
            <span class="k-text-uppercase dark">{{ 'SELECT-ORGANIZATION' | translate }}</span>
            <kendo-dropdownlist [(ngModel)]="selectedOrganizationId" class="w-100" [valuePrimitive]="true"
                [data]="activeOrganizations" [textField]="'name'" [valueField]="'id'"
                [ngModelOptions]="{standalone: true}">
            </kendo-dropdownlist>
        </label>
    </div>
    <kendo-dialog-actions>
        <button kendoButton #selectButton (click)="select()">{{ 'SELECT' | translate }}<i
                class="fal fa-hospital-user"></i>
        </button>
    </kendo-dialog-actions>
</kendo-dialog>